import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { isFunction } from "@cayuse/shared-react.utils.type-checks";

import { useDictionary } from "hooks";
import { useRuleTypeActionLabel } from "../../ConditionBuilder/hooks/useActionText";

import TeamPicker from "components/TeamPicker";
import RuleRowText from "../../RulesRenderer/RuleRowText/RuleRowText";

import styles from "./styles.css";

const TeamTypeDisplay = ({ onRuleChange, rule: originalRule }) => {
    const [rule, setRule] = useState(originalRule);
    const dictionary = useDictionary("ruleBuilder");
    const actionLabel = useRuleTypeActionLabel(rule.ruleType);

    const handleTeamChange = (newSelection) => {
        const updatedRule = {
            ...rule,
            targetId: newSelection.value,
        };

        setRule(updatedRule);

        if (isFunction(onRuleChange)) {
            onRuleChange(updatedRule);
        }
    };

    useEffect(() => {
        setRule(originalRule);
    }, [originalRule]);

    if (rule.isActionEditing) {
        return (
            <div
                data-component="Rules\List\ComponentBuilder\AdHocTeamReview"
                className={styles.adHocTeamReview}
            >
                <span dangerouslySetInnerHTML={{ __html: actionLabel }} />{" "}
                <TeamPicker
                    search
                    selection
                    underModal
                    onChange={handleTeamChange}
                    placeholder={
                        dictionary.selectTeamPlaceholder || "Select Team"
                    }
                    value={rule.targetId}
                />
            </div>
        );
    }

    return (
        <div data-component="Rules\List\ComponentBuilder\AdHocTeamReview">
            <RuleRowText column="action" rule={rule} />
        </div>
    );
};

TeamTypeDisplay.propTypes = {
    formType: PropTypes.string,
    isNew: PropTypes.bool,
};

export default TeamTypeDisplay;
